export function buildEstiaPaymentDeepLink(sessionOrIntentId: string): string {
  return `estiapayment://pay/v1/sdk/${sessionOrIntentId}`;
}

export function buildEstiaPosPaymentDeepLink(intentId: string): string {
  return `estiapayment://pay/v1/${intentId}`;
}
